module.exports = __webpack_public_path__ + "static/media/bonusSpins_75_100.c4346d5e.png";